const rankingItems = [
  { rank: 1, title: '暗夜追踪', type: '悬疑 / 犯罪', score: '8.7', trend: 'up', change: '+3' },
  { rank: 2, title: '星际迷途', type: '科幻 / 冒险', score: '9.0', trend: 'up', change: '+5' },
  { rank: 3, title: '山河故人', type: '剧情 / 文艺', score: '8.5', trend: 'same', change: '—' },
  { rank: 4, title: '极限追凶', type: '动作 / 犯罪', score: '8.3', trend: 'up', change: '+2' },
  { rank: 5, title: '夏目友人帐剧场版', type: '动画 / 治愈', score: '9.2', trend: 'down', change: '-1' },
  { rank: 6, title: '深海迷渊', type: '惊悚 / 冒险', score: '7.9', trend: 'up', change: '+8' },
  { rank: 7, title: '春日迟迟', type: '爱情 / 文艺', score: '8.1', trend: 'new', change: '新' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热度榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">实时更新的观影热度排行，看看大家都在看什么</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-primary-50/20 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.trend === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-100 text-accent-700 whitespace-nowrap">NEW</span>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="text-sm font-bold text-primary-600 font-heading">{item.score}</div>
                <div className={`text-xs font-medium ${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'down' ? 'text-secondary-500' :
                  item.trend === 'new' ? 'text-accent-500' : 'text-foreground-400'
                }`}>
                  {item.change}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}